<template>
  <div class="bodyMess">
    <div class="Mess_tip">
      <el-breadcrumb separator-icon="ArrowRight">
        <el-breadcrumb-item :to="{ path: '/' }">当前位置 : 首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Bidding' }">招标公告</el-breadcrumb-item>
        <el-breadcrumb-item>正文</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="Mess_content">
      <div class="Mess_title">{{Message.bulletinName}}</div>
      <div class="Mess_time">发布时间：{{Message.time}}  阅读次数：{{Message.readingTimes}}</div>
      <!-- <div class="Mess_btn">
        <a :href="AdData.loginAddress" target="_blank">
          <div class="Mess_btn_book">
            <img src="../img/books.png" alt="">
            获取标书
          </div>
        </a>
        <a :href="AdData.loginAddress" target="_blank">
          <div class="Mess_btn_make">
            <img src="../img/makes.png" alt="">
            我要投标
          </div>
        </a>
      </div> -->
      <div class="base-info">
        <el-descriptions :column="3" style="padding: 25px;box-sizing: border-box;">
          <el-descriptions-item label="项目编码:" label-class-name="my-label" content-class-name="my-content">{{ Message.gpCode }}
          </el-descriptions-item>
          <el-descriptions-item label="招标项目编码:">{{ Message.gtpCode }}</el-descriptions-item>
          <el-descriptions-item label="公告编码:">{{ Message.tbCode }}</el-descriptions-item>
          <el-descriptions-item label="招标地区:">{{ Message.regionName}}</el-descriptions-item>
          <el-descriptions-item label="采购人:">{{ Message.acName }}</el-descriptions-item>
          <el-descriptions-item label="招标方式:">{{ Message.tenderWayName }}</el-descriptions-item>
          <el-descriptions-item label="项目类型:">{{Message.tdrPrjClassifyName}}</el-descriptions-item>
          <el-descriptions-item label="截止时间:">{{ Message.bulletinEndTime }}</el-descriptions-item>
          <el-descriptions-item label="项目状态:">
            <span style="color: red;"> {{ Message.residueDays == -1 ? "已截止" : '进行中'  }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="base_content" v-html="Message.content"></div>
      <div
          class="content_content_fileInfo"
          v-for="fileItem in Message.file"
          :key="fileItem"
          @click="filestoHref(fileItem)"
        >
          <div class="content_content_fileInfo_title">
            {{ fileItem.oldName }}
          </div>
          <div class="content_content_fileInfo_content">
            <img :src="contentIcon" />
            <a :href="'/sino/api/cms/tenderBulletin/download' + '?attachId=' + fileItem.aulId" class="content_content_fileInfo_contetn_fileName">
              {{ fileItem.oldName }}
            </a>
          </div>
        </div>
      <!-- <div class="base_btn">
        <a :href="AdData.loginAddress" target="_blank">
          <div class="btn_bid">我要投标</div>
        </a>
        <a :href="AdData.registerAddress" target="_blank">
          <div class="btn_register">我要注册</div>
        </a>
      </div> -->
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import inspect from '@/api/validate'
import imgData from "@/data";
import { queryBulletinDetail, queryCmsSiteInfo } from '@/api/index.js';
export default {
  setup() {
    const router = useRouter();
    const bulletinType = ref()
    const tbId = ref()
    const Message = ref({})
    const LabMes = async () => {
      const res = await queryBulletinDetail({ bulletinType: bulletinType.value, tbId: tbId.value })
      Message.value = res.data
      console.log(res, 'res');
    }
    const AdData = ref({})
    const arr = async () => {
      let res = await queryCmsSiteInfo()
      AdData.value = res.data
    }
    onMounted(async () => {
      bulletinType.value = router.currentRoute.value.query.bulletinType;
      tbId.value = router.currentRoute.value.query.tbId;
      await LabMes()
      await arr()
    })
    return {
      ...imgData.BiddingInfoImg,
      bulletinType,
      tbId,
      Message,
      LabMes,
      AdData,
      arr
    };
  },
  methods: {
    // 获取列表ID对应的市
    getArrName(val, child) {
      const resp = inspect.getFullTreeName(val, child)
      if (resp.valArray) {
        return resp.valArray.join('')
      }
    },
    // 获取项目类型
    projectType(id, array) {
      // this.loading = true
      for (let i = 0; i < array.length; i++) {
        if (array[i].value == id) {
          return array[i].label // 如果找到匹配的ID，返回该对象
        }
        if (array[i].children) {
          const result = this.projectType(id, array[i].children) // 递归查找子对象数组
          if (result) {
            return result // 如果在子数组中找到匹配的ID，返回该对象
          }
        }
        // this.loading = false
      }
      // this.loading = false
      return null // 如果没有找到匹配的ID，返回null
    },
  }
};
</script>
<style>
@import url("./bodyMes.css");
a {
  text-decoration: none;
}
.el-descriptions__body {
  background: rgba(245, 247, 250, 1);
}
</style>